module.exports = __webpack_public_path__ + "img/ic_twitter.30c45a67.svg";